import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, from, switchMap } from 'rxjs'
import { agentSearchUserProfileUrl, agentCreateUserProfileUrl, agentPoolWebClientId } from '../common/utilities/constants'

@Injectable({
  providedIn: 'root'
})
export class AgentBookingService {
  constructor (private http: HttpClient) {}

  searchUserProfile (emailAddress: string, dateOfBirth: string): Observable<any> {
    return from(this.getAgentToken()).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'X-Skip-Interceptor': 'true'
        })
        return this.http.post<any>(agentSearchUserProfileUrl, { emailAddress, dateOfBirth }, { headers })
      })
    )
  }

  createUserProfile (firstName: string, lastName: string, emailAddress: string, dateOfBirth: string): Observable<any> {
    return from(this.getAgentToken()).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'X-Skip-Interceptor': 'true'
        })
        return this.http.post<any>(agentCreateUserProfileUrl, { firstName, lastName, emailAddress, dateOfBirth }, { headers })
      })
    )
  }

  private async getAgentToken (): Promise<string> {
    // Read token directly from RP-keyed cookie since Amplify's internal state uses TT pool
    const lastAuthUser = this.getCookieValue(`CognitoIdentityServiceProvider.${agentPoolWebClientId}.LastAuthUser`)
    if (lastAuthUser) {
      const accessToken = this.getCookieValue(`CognitoIdentityServiceProvider.${agentPoolWebClientId}.${lastAuthUser}.accessToken`)
      if (accessToken) {
        return accessToken
      }
    }
    return ''
  }

  private getCookieValue (name: string): string | null {
    const cookies = document.cookie.split('; ')
    for (const cookie of cookies) {
      const [key, ...valueParts] = cookie.split('=')
      if (key === name) {
        return decodeURIComponent(valueParts.join('=')) || null
      }
    }
    return null
  }
}
